const translations = {
    mainNav: {
        language: "Language",
        shoppingBasket: "Basket",
        login: "Login",
        logout: "Logout",
        register: "Register",
        user: "User",
        bookings: "Bookings",
        transfers: "Transfers",
        profile: "Profile",
    },
    footer: {
        legalNotice: "Legal notice",
        privacyPolicy: "Privacy policy",
        contractTerms: "Contract terms",
        cookiesPolicy: "Cookies policy",
        complaintChannel: "Complaint Channel"
    },
    bookingForm: {
        event: "Event",
        selectEventToBook: "Select the event to book",
        checkIn: "Check In",
        checkOut: "Check Out",
        guest: "Guest",
        guests: "Guests",
        addDate: "Add date",
        addGuest: "Add",
        numberOfRooms: "Rooms",
        adults: "Adults",
        children: "Children",
        roomNumber: "Room {{number}}"
    },
    bookingMeForm: {
        confirmationNumber: "Number",
        bookingStatus: "Status",
        paymentStatus: "Payment status",
        event: "Event",
        city: "City",
        hotel: "Hotel",
        year: "Year",
        name: "Booking status",
        searchByBookingStatus: "Search by booking status",
        searchByPaymentStatus: "Search by payment status",
        searchByConfirmationNumber: "Search by confirmation number",
        searchByEvent: "Search by event",
        searchByCity: "Search by city",
        searchByHotel: "Search by hotel",
        searchByYear: "Search by year",
        confirmed: "Confirmed",
        pending: "Pending",
        canceled: "Canceled",
        paid: "Paid",
        notPaid: "Not paid",
        refunded: "Refunded",
    },
    cityEventMainCard: {
        hotels: "Hotels",
        transferService: "Transfer service",
        from: "From",
        to: "Until",
    },
    hotelMapCard: {
        minNightsRequired: "This hotel requires a minimum of {{nights}} nights",
        discountCode: "{{code}}",
        forNight: "from <PriceFormatter>{{price}}</PriceFormatter> per night",
        externalRedirectTitle: "You’re about to leave our website",
        externalRedirectMessage: "You will be redirected to the Booking.com website to continue your reservation. Would you like to continue?",
        cancel: "Cancel",
        ok: "Go to Booking.com",
    },
    hotelDetail: {
        amenities: "Amenities",
        amenitiesDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        viewMoreAmenities: "View more amenities",
        informationAndExtras: "Information and Extras",
        informationAndExtrasDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        location: "Location",
        cancellationPolicy: "Cancellation Policy",
        modifyDates: "Modify dates",
        addRoom: "Add room",
        from: "From:",
        to: "To:",
        capacity: "Capacity:",
        total: "Total",
        roomAdded: "Room added",
        roomNotAvailable: "Room not available",
        roomNotAvailableAt: "There is no availability for these nights: {{dates}}",
        roomAvailableWithOverbooking: "Room with days pending confirmation",
        roomAvailableWithOverbookingAt: "Booking with days pending confirmation. Our team will check the availability on these nights and get back to you as soon as possible: {{dates}}",
        roomAvailableWithOverbookingOnRequest: "ON REQUEST",
        roomAvailableWithOverbookingConfirm: "Please click confirm to continue.",
        hotelNotAvailable: "You cannot add rooms from different hotels",
        addRoomErrorTitle: "An error ocurred.",
        addRoomError: "An error occurred and the room could not be added to the basket",
        goToCheckout: "Go to checkout",
        details: "Details",
        quantity: "Quantity",
    },
    common: {
        actions: {
            add: "Add",
            accept: "Accept",
            cancel: "Cancel",
            edit: "Edit",
            delete: "Remove",
            submit: "Send",
            save: "Save",
            upload_file: "Upload file",
            search: "Search",
            show_more_filters: "Show more filters",
            hide_more_filters: "Hide more filters",
            clear: "Clear",
            back: "Back",
            goHome: "Go Home",
            copy: "Copy",
            confirm: "Confirm",
            loading: "Loading",
            select: "Select",
            selected: "Selected",
            close: "Close",
            send: "Send",
            loginOrRegisterMsg: "<LoginLink>Log in</LoginLink> or <RegisterLink>register</RegisterLink> to save your reservation and access it anytime!",
            next: "Next",
            previous: "Previous",
            sending: "Sending",
            complete: "Complete",
            unSelect: "Clear Selection",
        },
        labels: {
            required_field: "Required field",
            filters: "Filters",
            none: "None",
            all: "All",
            creation_date: "Creation date",
            error: "Error",
            administration: "Administration",
            actions: "Actions",
            selected_items: "{{count}} Selected Items",
            per_page: "Per page",
            sort_by: "Sort by",
            total: "Total",
            language: "Language",
            iAcceptThe: "I have read and I accept the <AcceptButton>{{terms}}</AcceptButton>",
        },
        feedback: {
            saved_data: "Data saved successfully",
            no_data: "No data",
            form_not_valid: "There are errors in the form",
            field_required: "The field is required",
            field_min: "The field value cannot be less than {{min}}",
            field_max: "The field value cannot be greater than {{max}}",
            field_min_length:
                "The field length cannot be less than {{length}}",
            field_max_length:
                "The field length cannot be greater than {{length}}",
            field_valid_email: "{{value}} is not a valid email",
            field_valid_iban: "{{value}} is not a valid IBAN",
            unexpected_error: "An unexpected error has occurred",
            field_required_terms: "You must read and accept the {{terms}}",
            time_cannot_be_in_past: "The time cannot be less than the current time",
        },
        enum: {
            transportType: {
                plane: "Airplane",
                train: "Train",
                bus: "Bus",
                other: "Other",
            },
            transferDirection: {
                oneWay: "Arrival",
                comeBack: "Departure",
                both: "Round trip",
            },
            transferVehicle: {
                sedan: "Sedan",
                van: "Van",
                businessSedan: "Business Sedan",
                businessVan: "Business Van",
            },
            transferStatus: {
                pending: "Pending",
                transferCreated: "Transfer Created",
                updated: "Updated",
                cancelled: "Cancelled",
                confirmed: "Confirmed",
                requestInfo: "Request Information",
                formSent: "Form Submitted",
            },
        }
    },
    auth: {
        actions: {
            sign_in: "Sign In",
            logout: "Log Out",
            reset_password: "Restore password",
        },
        fields: {
            email: "Email address",
            password: "Pasword",
            new_password: "New password",
            confirm_new_password: "Confirm new password",
        },
        labels: {
            forgot_password: "Have you forgotten the password?",
            forgot_password_subheading:
                "Enter your email to reset your password",
        },
        feedback: {
            unauthorized: "The session is invalid",
            passwords_does_not_match: "Passwords do not match",
        },
    },

    error404: {
        labels: {
            heading:
                "Sorry, we can't seem to find the page you're looking for.",
            subheading:
                "There may be a misspelling in the URL you entered, or the page you're looking for no longer exists.",
        },
    },

    home: {
        title: "Inicio",
    },
    cart: {
        title: "Carrito",
    },
    checkout: {
        title: "Booking details",
        continueShopping: "Continue shopping",
        noItemsInTheCart: "There are no items in the cart",
        total: "Total",
        total_without_taxes: "Total without taxes",
        total_taxes: "Taxes",
        total_basket: "Total Booking",
        total_pending: "Total Pending",
        discount: "Discount",
        total_to_pay: "Total to pay",
        total_payed: "Total payed",
        confirm_booking: "Confirm booking",
        clear_basket: "Clear basket",
        total_nights: "Nights",
        nights: "nights",
        night_of: "Night of",
        from: "From",
        to: "To",
        delete: "Delete",
        book_price_detail: "Book price detail",
        errorWithPaymentItWillBeRefund: "An error has occurred during the payment process. If the payment has been processed, it will be refunded in full as soon as possible. Please contact an administrator if the error persists.",
        status: {
            name: "Status",
            pending: "Pending",
            confirmed: "Confirmed",
            canceled: "Canceled",
        },
        paymentStatus: {
            unpaid: "Unpaid",
            payment_requested: "Payment requested",
            payment_scheduled: "Scheduled payment",
            paid: "Paid",
            refunded: "Refunded",
        },
    },
    booking: {
        title: "Confirmation and payment",
        noBookings: "You don't have any reservations yet.",
        personalInformation: "Personal information",
        paymentInformation: "Payment information",
        invoiceInformation: "Invoice information",
        name: "Name",
        surname: "Surname",
        email: "Email",
        telephone: "Telephone",
        invalidTelephone: "Please enter a valid telephone number",
        roomsWithOverbookingDisclaimer: "Thank you very much for your reservation. We will contact you as soon as possible, as this reservation is pending confirmation for the following days.",
        roomsToBePaidAtTheHotelDisclaimer: "This reservation contains rooms to be paid at the hotel and the credit card details are required to guarantee the room with the hotel.",
        paymentRequiredDisclaimer: "Someone from the Love Events team will contact you shortly to make the payment.",
        creditCardInformation: "Credit card information",
        creditCardHolder: "Credit card holder",
        creditCardNumber: "Credit card number",
        invalidCreditCardNumber: "Please enter a valid credit card number",
        expiration: "Expiration",
        invalidCreditCardExpiration: "The expiration date of the credit card must be after the date of the reservation",
        invalidCreditCardExpirationActualDate: "The expiration date of the credit card must be after the current date",
        roomDetails: "Room details",
        room: "Room",
        guests: "Guests",
        guestN: "Guest {{number}}",
        child: "Child",
        checkInTime: "Check in time",
        iDontKnow: "I don't know",
        comments: "Comments",
        acceptTerms: "I have read and I accept ",
        termsAndConditions: "Terms & Conditions",
        submit: "Finalise the booking",
        formContainsErrors: "The form contains errors. Please check them.",
        errorWhenMakingTheBookingHeading: "Error when making the reservation",
        errorWhenMakingTheBookingBody: "An error has occurred while making the reservation. Please try again. If the problem persists, contact us.",
        prebookingHasExpiredError: "Your pre-booking has expired after {{prebookingExpiresIn}} minutes of inactivity. Please start the booking process again.",
        bookingDetails: "Booking details",
        bookingDetailsSubtitle: "Personal information of the booking",
        invoiceNameAndSurname: "Full name",
        nationality: "Nationality",
        documentType: "Document Type",
        passport: "Passport",
        nie: "NIE",
        dni: "DNI",
        nif: "NIF",
        vat: "VAT",
        other: "Other",
        invalidDocumentTypeFormat: "Invalid {{documentType}} format",
        invalidDocumentTypeLetter: "Invalid {{documentType}} letter",
        invalidNIEFormat: "Invalid NIE format",
        invalidNIELetter: "Invalid NIE letter",
        invoicePassportCif: "Number",
        invoiceAddress: "Fiscal address",
        payment: "Payment",
        scheduledPaymentDisclaimer: "A first payment of {{amount}} will be made. On the day {{nextPaymentDate}} the rest of the amount ({{nextPaymentAmount}}) will be automatically charged.",
    },
    bookOk: {
        creditCard: "Card Pay",
        yourBooking: "Your booking",
        bookingConfirmed: "Your booking has been confirmed",
        bookingConfirmedAndPaid: "Your booking has been confirmed and paid",
        bookingScheduledPayment: "A payment of {{nextPaymentAmount}} has been scheduled for {{nextPaymentDate}}. Once completed, your booking will be confirmed and you will receive a confirmation email.",
        bookingCanceled: "Your booking has been canceled",
        boolingCanceledAndRefunded: "Your booking has been canceled and refunded",
        roomsWithOverbookingDisclaimer: "Thank you very much for your reservation. We will contact you as soon as possible, as this reservation is pending confirmation for the following days.",
        rememberPayHotel: "Remember, when you arrive to the hotel, you will need to pay ",
        statusBookingNotOverbooking: 'Status of your booking: Room reserved and pending payment.',
        statusBookingOverbooking: 'Status of your booking: Room blocked and pending confirmation.',
        needToPay: 'We have received your reservation. This hotel requires advance payment.',
        rememberPay: "We have received your reservation. This hotel requires advance prepayment for the booking. You may make the payment now <PayCometIcon/> or you can make the payment one month before the event starts. In that case, a payment link will be sent to you by email.",
        selectPaymentMethod: "Select your preferred payment method:",
        confirmationNumber: "Confirmation number",
        nameAndSurnames: "Name and surnames",
        email: "Contact email",
        telephone: "Contact telephone",
        hotelDetails: "Hotel details",
        hotelDetailsSubtitle: "Information about the booked accommodation",
        event: "Event",
        city: "City",
        hotel: "Hotel",
        address: "Address",
        payMethod: "Method payment",
        payOnHotel: "Pay at the hotel",
        roomDetails: "Room Details",
        roomDetailsSubtitle: "Rooms included in your booking",
        roomType: "Room type",
        occupancy: "Occupancy",
        arrivalHour: "Arrival hour",
        guest: "Guest",
        total: "Total",
        transferServiceDescription: "If you wish, you can book a transfer with us to complete your experience.",
        bookTransfer: "Book Transfer",
        totalPending: "Total pending",
        paymentsMade: "Payments made",
        taxesAndFees: "Taxes and fees",
        discount: "Discount",
        totalBasket: "Total booking",
        totalPaid: "Total paid",
        taxes: "Taxes",
        totalRooms: "Total accommodation",
        totalRoomsSubtitle: "Amount for the stay and selected rooms",
        summaryTitle: "Booking summary",
        summarySubtitle: "Below you can see the breakdown of the charges for your booking.",
        totalPendingSubtitle: "Remaining amount to pay",
        paymentsSubtitle: "Amount you have already paid",
        taxesSubtitle: "Taxes applicable to your booking",
        payment: 'Payment',
        payments: "Payments",
        refund: "Refund",
        refunds: "Refunds",
        refundsSubtitle: "Amount that has been refunded from your booking",
        paymentDateUnknown: "Unknown date",
        paymentMethod: "Method",
        paymentDate: "Date",
        noPayments: "No payments",
        payWithSelectedCard: "Pay with selected card",
        processing: "Processing...",
        paymentError: "Payment error. Please try again.",
        payByCard: "Card",
        payAmount: "Pay {{amount}}",
        payWithLuxon: "Pay {{amount}} with Luxon",
        luxonDescription: "Pay quickly and securely with Luxon, the payment method for leisure and events.",
        redirecting: "Redirecting...",
        payNow: "Pay now",
        payLater: "Pay later",
        schedulePayment: "Schedule payment",
        schedulePaymentAmount: "Schedule payment of {{amount}}",
        scheduledPaymentInfoTotalHead: "Today only a 0.01 verification will be performed, which will be automatically refunded.",
        scheduledPaymentInfoTotal: "The total amount of the reservation will be automatically charged to the registered card on the indicated date.",
        scheduledPaymentInfoPartialHead: "The amount that will be charged today is an initial payment to guarantee the reservation.",
        scheduledPaymentInfoPartial: "The remaining amount of the reservation will be automatically charged to the registered card on the indicated date.",
        paymentBreakdown: "Payment breakdown",
        initialPayment: "Initial payment today",
        preauthorization: "Card verification",
        remainingPayment: "Remaining payment on {{date}}",
        totalAmount: "Total amount",
    },
    transfers: {
        fields: {
            transferDetails: "Transfer Details",
            personalDetails: "Personal Details",
            passengerName: "First Name",
            passengerLastName: "Last Name",
            passengerContactEmail: "Email",
            passengerPhoneNumber: "Phone Number",
            dialCode: "Country Code",
            oneWayTransfer: "Arrival Transfer",
            returnTransfer: "Departure Transfer",
            arrivalTransport: "Arrival Transport",
            arrivalLocationFrom: "Arrival Location",
            arrivalLocationFromAirplane: "Arrival Airport",
            arrivalLocationFromTrain: "Arrival Station",
            arrivalLocationFromBus: "Arrival Station",
            arrivalLocationTo: "Going To",
            departureTransport: "Departure Transport",
            departureLocationFrom: "Pick up Location",
            departureLocationToAirplane: "Departure Airport",
            departureLocationToTrain: "Departure Station",
            departureLocationToBus: "Departure Station",
            departureLocationTo: "Destination",
            arrivalLocationFromDetails: "Arrival address details",
            arrivalLocationToDetails: "Drop-off address details",
            departureLocationFromDetails: "Pick-up address details",
            departureLocationToDetails: "Destination address details",
            arrivalTransportDate: "Arrival Date",
            flightArrivalDate: "Flight Arrival Date",
            trainArrivalDate: "Train Arrival Date",
            busArrivalDate: "Bus Arrival Date",
            departureTransportDate: "Departure Date",
            flightDepartureDate: "Flight Departure Date",
            trainDepartureDate: "Train Departure Date",
            busDepartureDate: "Bus Departure Date",
            arrivalTransportTime: "Arrival Time",
            flightArrivalTime: "Flight Arrival Time",
            trainArrivalTime: "Train Arrival Time",
            busArrivalTime: "Bus Arrival Time",
            departureTransportTime: "Departure Time",
            flightDepartureTime: "Flight Departure Time",
            trainDepartureTime: "Train Departure Time",
            busDepartureTime: "Bus Departure Time",
            arrivalNumberOfPassengers: "Number of Passengers (Arrival)",
            departureNumberOfPassengers: "Number of Passengers (Departure)",
            pickUpTime: "Pick Up Time",
            pickUpTimeHelper: "To ensure a seamless departure experience, we recommend selecting a pick-up time that allows at least 2 hours before your flight, plus the travel time to the airport",
            airline: "Airline",
            flightNumber: "Flight Number",
            trainCompany: "Train Company",
            trainNumber: "Train Number",
            busCompany: "Bus Company",
            busNumber: "Bus Number",
            transportReference: "Transport Reference",
            transportReferenceNumber: "Transport Reference Number",
            comments: "Comments",
            sedan: "Sedan",
            van: "Van",
            businessSedan: "Business Sedan",
            businessVan: "Business Van",
            maxPassengers: "Max. Passengers",
            direction: "Direction",
            status: "Status",
            price: "Price",
            confirmationNumber: "Confirmation Number",
            vehicle: "Vehicle",
            luggageCapacity: "Luggage Capacity",
            termsAndConditions: 'Transfer Terms & Conditions',
            termsAndConditionsInfo: {
                cancellation: 'Cancellation Policy: Airport transfers cannot be cancelled free of charge within 24 hours of the scheduled pickup time. Cancellations made less than 24 hours before the transfer are non-refundable.',
                missedFlights: 'Missed Flights: If you miss your flight and require a new transfer, this will be treated as a new booking and charged accordingly.',
                flightDelays: 'Flight Delays: If your flight is delayed, do not worry, your driver will monitor your flight and adjust the pickup time based on the actual flight arrival time.',
            },
        },
        message: {
            typeOfTransfer: "Type of Transfer",
            formTitle: "Airport Transfer Service",
            transferDetailsSent: "Transfer details have been sent to {{email}}",
            succesCreatingRequestTransfer: "Your transfer request has been sent successfully. ",
            newTransferRequest: "Request new transfer",
            confirmationShortly: "We will check all the details and send you a confirmation email shortly.",
            paymentEmailNotice: "You will shortly receive an email with a payment link. Once the payment has been completed, we will confirm your transfer.",
            anyChanges: "For any changes, please contact: {{email}}.",
            mustReadTerm: "You must accept the terms and conditions",
            noVehiclesAvailable: "No vehicles available",
            termsLinkMessage: "I accept the",
            termsTitle: "Terms and Conditions",
            footerDescription2: "You will receive a confirmation of your request at {{customerEmail}}",
            comments: "Comments",
            selectTransportFirst: "Select transport first",
            selectArrivalLocationFromFirst: "Select an arrival location first",
            selectDepartureLocationFromFirst: "Select a departure location first",
            enterAddressDetails: "Please enter the detailed address (street, building, apartment number, etc.)",
            selectVehicleArrival: "Select your arrival vehicle",
            selectVehicleDeparture: "Select your departure vehicle",
            customRoute: "We will look into the cost for this personalised route for you and send you the price by email within 24 hrs",
            noTransfers: "You don't have any transfers yet.",
            toConfirm: "To confirm"
        },
    },
    transferSearch: {
        fields: {
            city: "City",
        },
        message: {
            searchByDirection: "Search by direction",
            searchByTransferStatus: "Search by transfer status",
            searchByConfirmationNumber: "Search by confirmation number",
            searchByEvent: "Search by event",
            searchByHotel: "Search by hotel",
            searchByYear: "Search by year",
            searchByCity: "Search by city",
        }
    },
    transferOk: {
        fields: {
            nameAndSurnames: "Name and Surname",
            event: "Event",
            totalTransfer: "Transfer Total",
            totalTransferSubtitle: "Amount for the selected transfer",
            totalToPay: "Total to Pay",
            totalPaid: "Total Paid",
            numberOfPassengers: "Number of Passengers",
            locationFrom: "From",
            locationTo: "To",
            person: "person",
            persons: "persons",
            arrivalInstructions: "Arrival Instructions",
            departureInstructions: "Departure Instructions"
        },
        message: {
            yourTransfer: "Your Transfer Booking",
            transferConfirmed: "Your transfer has been confirmed.",
            transferConfirmedAndPaid: "Your transfer has been confirmed and paid.",
            transferPaymentRequested: "Your transfer payment has been requested.",
            transferPending: "Your transfer is pending confirmation.",
            transferCanceled: "Your transfer has been canceled.",
            transferCanceledAndRefunded: "Your transfer has been canceled and refunded.",
            transferDetails: "Transfer Details",
            personalDetails: "Personal Details",
            eventDetails: "Event Details",
            bookAnotherTransfer: "Book Another Transfer",
            sharedWithPassenger: "Shared with",
            flightDetails: "Flight Details",
            trainDetails: "Train Details",
            busDetails: "Bus Details",
            transportDetails: "Transport Details",
            personalDetailsSubtitle: "Personal information about your transfer",
            eventDetailsSubtitle: "Event information for your transfer",
            transportDetailsSubtitle: "Transport information",
            transferDetailsSubtitle: "Transfer information",
        }
    },
    terms: {
        labels: {
            readCompleteDocument: "Read the complete document.",
            revised: "reviewed",
            scrollToTheEnd: "Scroll to the bottom",
            documentRevised: "Document reviewed",
            mustReadAllDocument: "You must review the complete document before accepting it.",
        }
    },
    paymentCard: {
        saveCard: "Save card",
        cardSavedSuccess: "Your card has been saved successfully",
        noSavedCards: "You have no saved cards",
        selectCard: "Select payment card",
        addCard: "Add new card",
        cancelAddCard: "Cancel",
        saveAndSelect: "Save and select",
        mustSelectCard: "You must select a card to continue",
        changeCard: "Change card",
        cardAdded: "Card added",
        securePayment: "Secure payment with SSL encryption",
        primary: 'Primary',
        isPrimary: "Primary Card",
        setPrimary: 'Set as Primary Card',
    },
    packages: {
        fields: {
            selectARoom: 'Select a room',
            selectRoom: 'Select Room',
            addMoreRooms: 'Add more rooms',
            completePersonalDetails: 'Complete personal details',
            completeTransferDetails: 'Complete transfer details',
            personalDetails: 'Personal Details',
            personalDetailsDescription: 'Complete your personal details to finalize your booking',
            addAnotherTransfer: 'Add another transfer',
        },
        message: {
            winnerPackageNoticeBanner: "Congratulations on winning a package for {{cityEvent}} from {{startDate}} to {{endDate}}.",
            packageIncludedOneTransfer: "Congratulations, your package includes one complimentary transfer on arrival or departure. Please complete the details to continue.",
            packageIncludedNoTransfer: "Congratulations, your package does not include transfers. Please complete your personal details to finalize your booking.",
            confirmAccommodationDates: 'Confirm accommodation dates',
            canCheckInEarlierOrCheckOutLater: 'If needed, you can arrive earlier or leave later than your accommodation dates.',
            canBookAnotherTransfer: 'If needed, you can book an additional transfer with us, but this one must be paid for.',
            optionalTransferAllOrNothing: 'You started filling in the additional transfer. Complete all fields or leave it empty to continue.',
        },
        validation: {
            selectRoomDescription: "Select a room to continue",
            addMoreIfYouNeed: "If you want to add more additional rooms to the one you have already won, select them. Otherwise, continue.",
            completePersonalDetails: "Complete personal details to continue",
            roomRequired: "You must select a room",
            personalDetailsRequired: "You must complete your personal details",
            datesRequired: "You must select accommodation dates",
            startDateTooEarly: "The start date cannot be earlier than {{minStartDate}}",
            endDateTooLate: "The end date cannot be later than {{maxEndDate}}",
            invalidDateRange: "The start date must be earlier than the end date",
            startDateOutOfRange: "The start date must be between {{minDate}} and {{maxDate}}",
            endDateOutOfRange: "The end date must be between {{minDate}} and {{maxDate}}",
            startDateBeforeEvent: "The start date cannot be before the event start date ({{eventStartDate}})",
            endDateAfterEvent: "The end date cannot be after the event end date ({{eventEndDate}})",
        }
    },
};

export default translations;
